import React from 'react';
import { FILTERED_DOCUMENT_SELECTION_FILTERS, FilteredDocumentsSelection } from './FilteredDocumentsSelection';
import { FilterableDocumentsContextProvider } from '@/contexts/FilterableDocumentsContext';
import { FormStateContext } from '@/contexts/FormStateContext';
import { fetchDocumentsForTags } from '@utils/doc';

export const CompanyDocumentSelection = () => {
  const { state: formState } = React.useContext(FormStateContext);
  const [initializing, setInitializing] = React.useState(true);

  const docGetter = async () => {
    if (formState.tags.length === 0) {
      setInitializing(false);
      return null;
    }
    const docs = await fetchDocumentsForTags(formState.tags);
    setInitializing(false);
    return docs;
  };

  return (
    <FilterableDocumentsContextProvider docGetter={docGetter}>
      <FilteredDocumentsSelection
        filterModes={[
          FILTERED_DOCUMENT_SELECTION_FILTERS.tags,
          FILTERED_DOCUMENT_SELECTION_FILTERS.documentTypes,
          FILTERED_DOCUMENT_SELECTION_FILTERS.reportingPeriods,
        ]}
        initializing={initializing}
      />
    </FilterableDocumentsContextProvider>
  );
};
